import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, Calendar, User, Loader2 } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlogPostPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/blog/${id}`).then(r => r.json()).then(d => { setPost(d); setLoading(false); }).catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="flex justify-center py-32"><Loader2 className="h-8 w-8 animate-spin text-[#00E5FF]" /></div>;
  if (!post) return <div className="text-center py-32 text-zinc-500">Post not found</div>;

  return (
    <div className="px-6 md:px-12 max-w-4xl mx-auto py-12 md:py-20" data-testid="blog-post-page">
      <button onClick={() => navigate('/blog')} className="flex items-center gap-2 text-sm text-zinc-500 hover:text-[#00E5FF] mb-8 transition-colors" data-testid="blog-back-btn">
        <ArrowLeft className="h-4 w-4" /> Back to Blog
      </button>

      <article className="bg-[#0A0A0A] border border-white/5 rounded-sm p-8 md:p-12">
        <div className="flex items-center gap-3 mb-6">
          <Badge variant="outline" className="border-zinc-700 text-zinc-500 text-xs uppercase">{post.category}</Badge>
          <div className="flex items-center gap-4 text-xs text-zinc-600">
            <span className="flex items-center gap-1"><Eye className="h-3 w-3" /> {post.views}</span>
            <span className="flex items-center gap-1"><User className="h-3 w-3" /> {post.author}</span>
            <span className="flex items-center gap-1"><Calendar className="h-3 w-3" /> {new Date(post.created_at).toLocaleDateString()}</span>
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-white font-['Outfit'] tracking-tight mb-8">{post.title}</h1>

        <div className="prose prose-invert max-w-none text-zinc-400 leading-relaxed [&_h2]:text-white [&_h2]:font-['Outfit'] [&_h2]:text-xl [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-4 [&_strong]:text-white [&_p]:mb-4 [&_ul]:mb-4 [&_li]:mb-1 [&_ol]:mb-4">
          {post.content.split('\n').map((para, i) => {
            if (para.startsWith('**') && para.endsWith('**')) {
              return <h2 key={i}>{para.replace(/\*\*/g, '')}</h2>;
            }
            if (para.startsWith('- ')) {
              return <li key={i} className="ml-4 list-disc">{para.replace(/^- /, '').replace(/\*\*/g, '')}</li>;
            }
            if (para.match(/^\d+\./)) {
              return <li key={i} className="ml-4 list-decimal">{para.replace(/^\d+\.\s*/, '').replace(/\*\*/g, '')}</li>;
            }
            if (para.trim() === '') return null;
            return <p key={i} dangerouslySetInnerHTML={{ __html: para.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />;
          })}
        </div>
      </article>
    </div>
  );
}
